import {DealsLog} from "../../models/DealsLog";
import {WrapperFactory} from "../WrapperFactory";

let dealsLogsApi = {
    async create(dealsLog, token, companyId){
        let response = await window.axios.post('/api/deals-logs', dealsLog, {
            params:{
                api_token:token,
                company_logged:companyId
            }
        });

        return new DealsLog(response.data);
    },
    async get(token, companyId, filters = {}, page=1){
        let response = await window.axios.get('/api/deals-logs', {
            params:{
                api_token:token,
                company_logged:companyId,
                page:page,
                ...filters
            }
        });

        let wrapper = WrapperFactory.fromResponse(response.data);
        wrapper.transform(e=>new DealsLog(e));
        return wrapper;
    }
}

export default dealsLogsApi